(() => {
  const mobileOnly = window.matchMedia("(max-width: 749px)");

  /*
   * Disable the product-image lightbox on mobile.
   */
  const lightboxOpeners = [
    "modal-opener",
    ".product__media-toggle",
    "[data-product-media-opener]",
    "button[aria-haspopup='dialog'][data-media-id]"
  ].join(",");

  function blockMobileLightbox(event) {
    if (!mobileOnly.matches) return;
    if (!(event.target instanceof Element)) return;
    if (!event.target.closest(lightboxOpeners)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
  }

  document.addEventListener("click", blockMobileLightbox, true);

  document.addEventListener("touchend", blockMobileLightbox, {
    capture: true,
    passive: false
  });

  document.addEventListener(
    "keydown",
    (event) => {
      if (!mobileOnly.matches) return;
      if (event.key !== "Enter" && event.key !== " ") return;
      if (!(event.target instanceof Element)) return;
      if (!event.target.closest(lightboxOpeners)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  /*
   * Correct the mobile image-counter total.
   */
  const counterSelector = ".slider-counter--total";
  const lastCorrectedValues = new WeakMap();

  let updateScheduled = false;

  function correctMobileImageCounter() {
    updateScheduled = false;

    if (!mobileOnly.matches) return;

    document.querySelectorAll(counterSelector).forEach((counter) => {
      const rawValue = counter.textContent.trim();
      const total = parseInt(rawValue, 10);

      if (!Number.isFinite(total) || total < 1) return;
      if (lastCorrectedValues.get(counter) === rawValue) return;

      const correctedTotal = String(Math.max(1, total - 1));

      counter.textContent = correctedTotal;
      lastCorrectedValues.set(counter, correctedTotal);
    });
  }

  function scheduleCounterFix() {
    if (updateScheduled) return;

    updateScheduled = true;
    requestAnimationFrame(correctMobileImageCounter);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleCounterFix);
  } else {
    scheduleCounterFix();
  }

  new MutationObserver(scheduleCounterFix).observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();



